import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { BsFingerprint } from "react-icons/bs";
import { FaPrayingHands } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import BottomNavbar from "../components/BottomNavbar";
import { fetchJadwalHariIni } from "../services/jadwalService";
import { fetchNamaGuru } from "../services/akunService";
import { kirimPresensiHadir } from "../services/presensiService";
import { useNavigate } from "react-router-dom"; 

function Dashboard() {
  const currentDate = new Date();
  const hari = currentDate.toLocaleDateString("id-ID", { weekday: "long" });
  const tanggal = currentDate.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const navigate = useNavigate();
  const [jadwal, setJadwal] = useState(null);
  const [namaSiswa, setNamaSiswa] = useState("");
  const [kelas, setKelas] = useState("");
  const [namaGuru, setNamaGuru] = useState("-");
  const [showPresensiModal, setShowPresensiModal] = useState(false);
  const [presensiLoading, setPresensiLoading] = useState(false);

  const normalizePembimbing = (value) => {
    const normalized = String(value || '').trim();
    if (!normalized || ['-', 'guru pembimbing', 'pembimbing'].includes(normalized.toLowerCase())) {
      return null;
    }
    return normalized;
  };

  const handlePresensi = () => {
    setShowPresensiModal(true);
  };

  const submitPresensi = async () => {
    setPresensiLoading(true);
    const result = await kirimPresensiHadir();
    setPresensiLoading(false);
    setShowPresensiModal(false);

    if (result.success) {
      alert("Presensi berhasil: " + result.message);
    } else {
      alert("Presensi gagal: " + result.message);
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    const nama = localStorage.getItem("nama");
    const kelas = localStorage.getItem("kelas");
    const pembimbing = normalizePembimbing(localStorage.getItem("guru_pembimbing"));

    setNamaSiswa(nama || "Siswa");
    setKelas(kelas || "Kelas");
    setNamaGuru(pembimbing || "-");

    if (userId) {
      fetchJadwalHariIni(userId).then((data) => {
        if (data) {
          setJadwal(data);
          if (data.nama_guru) {
            setNamaGuru(data.nama_guru);
          }
        }
      });
    }

    // Akun lama belum menyimpan nama pembimbing dari response login.
    // Pertahankan fallback pencarian berdasarkan ID untuk sesi tersebut.
    if (!pembimbing) {
      fetchNamaGuru().then((nama) => {
        if (nama) {
          localStorage.setItem("guru_pembimbing", nama);
          setNamaGuru(nama);
        }
      });
    }
  }, []);

  return (
    <Container
      className="py-4"
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        paddingBottom: "80px",
      }}
    >
      <div className="mb-3">
        <h5 className="fw-bold">
          {namaSiswa} / {kelas}
        </h5>
        <p className="text-muted mb-0">Pembimbing: {namaGuru}</p>
      </div>

      <Card
        className="text-white text-center rounded-4 mb-4"
        style={{ backgroundColor: "#007bba" }}
      >
        <Card.Body>
          <h5 className="fw-bold mb-1">{hari}</h5>
          <p className="mb-3">{tanggal}</p>
          <Row>
            <Col>
              <small>Presensi Masuk</small>
              <h5 className="fw-bold">
                {jadwal ? jadwal.jam_masuk || "-" : "-"}
              </h5>
            </Col>
            <Col>
              <small>Presensi Keluar</small>
              <h5 className="fw-bold">
                {jadwal ? jadwal.jam_keluar || "-" : "-"}
              </h5>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <div className="text-center mb-5">
        <h5 className="fw-bold mb-3">Presensi disini</h5>
        <div
          onClick={handlePresensi}
          role="button"
          className="d-inline-flex justify-content-center align-items-center rounded-circle border border-3"
          style={{
            width: "120px",
            height: "120px",
            borderColor: "#007bba",
            cursor: "pointer",
          }}
        >
          <BsFingerprint size={60} color="#007bba" />
        </div>
      </div>

      <Card
        className="border-0 shadow-sm rounded-4 mb-4"
        role="button"
        onClick={() => navigate("/presensi-ibadah")}
        style={{ cursor: "pointer" }}
      >
        <Card.Body className="d-flex align-items-center">
          <div className="rounded-circle bg-primary-subtle text-primary p-3 me-3">
            <FaPrayingHands size={24} />
          </div>
          <div className="flex-grow-1">
            <h6 className="fw-bold mb-1">Presensi Ibadah</h6>
            <small className="text-muted">Catat ibadah sesuai agama atau kepercayaan</small>
          </div>
          <span className="text-primary">›</span>
        </Card.Body>
      </Card>

      <Card
        className="border-0 shadow-sm rounded-4 mb-4"
        role="button"
        onClick={() => navigate("/jadwal")}
        style={{ cursor: "pointer" }}
      >
        <Card.Body className="d-flex align-items-center">
          <div className="rounded-circle bg-info-subtle text-info p-3 me-3">
            <FaCalendarAlt size={24} />
          </div>
          <div className="flex-grow-1">
            <h6 className="fw-bold mb-1">Jadwal PKL</h6>
            <small className="text-muted">
              {jadwal ? "Lihat atau ubah jadwal presensi" : "Jadwal belum diisi, isi sekarang"}
            </small>
          </div>
          <span className="text-info">›</span>
        </Card.Body>
      </Card>

      <div
        className="position-fixed end-0 p-4"
        style={{ bottom: "70px", zIndex: 1000 }}
      >
        <Button
          className="rounded-4 shadow"
          variant="light"
          onClick={() => navigate("/izin")}
          style={{ border: "1px solid #ccc" }}
        >
          <span className="me-1">+</span> Izin
        </Button>
      </div>

      <BottomNavbar />

      {showPresensiModal && (
        <div
          className="modal d-block"
          role="dialog"
          aria-modal="true"
          aria-labelledby="presensiConfirmTitle"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
            width: "100%",
            height: "100%",
          }}
        >
          <div className="modal-dialog modal-dialog-centered px-3">
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h5 className="modal-title fw-bold" id="presensiConfirmTitle">
                  Konfirmasi Presensi
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Tutup"
                  onClick={() => setShowPresensiModal(false)}
                  disabled={presensiLoading}
                />
              </div>
              <div className="modal-body">
                <p className="mb-0">Kamu yakin ingin presensi sekarang?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowPresensiModal(false)}
                  disabled={presensiLoading}
                >
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submitPresensi}
                  disabled={presensiLoading}
                >
                  {presensiLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Mengirim...
                    </>
                  ) : (
                    "Ya, Presensi"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
}

export default Dashboard;
